import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import useCart from '../../../data/useCart'
import useMutationWithErrorHandling from '../../../data/useMutationWithErrorHandling'
import getPhoenixUrlParams from '../../../lib/get-phoenix-url-params'
import { PatronQuestionInitialValues, PatronQuestionType } from '../../../typings/AdditionalInformation'
import SkeletonPatronQuestion from '../Skeletons/SkeletonPatronQuestion'

import {
  PatronQuestionCartDocument,
  PatronQuestionCartQuery,
  PatronQuestionSetPatronQuestionOnCartDocument,
  PatronQuestionSetPatronQuestionOnCartMutation,
  PatronQuestionSetPatronQuestionOnCartMutationVariables,
} from '../../../graphql'
import PatronQuestionComponent from './PatronQuestionComponent'

const PatronQuestion: React.FC<React.PropsWithChildren<unknown>> = () => {
  const location = useLocation()
  const { cartId } = getPhoenixUrlParams(location.search)

  const [initialValues, setInitialValues] = useState<PatronQuestionInitialValues>()

  const { cartData, isCartLoading } = useCart<PatronQuestionCartQuery>(PatronQuestionCartDocument)

  const [setPatronQuestionOnCart] = useMutationWithErrorHandling<
    PatronQuestionSetPatronQuestionOnCartMutation,
    PatronQuestionSetPatronQuestionOnCartMutationVariables
  >(PatronQuestionSetPatronQuestionOnCartDocument, {})

  useEffect(() => {
    if (!cartData) return

    const patronQuestionInitialValue =
      cartData.cart.patronQuestionInput !== null ? String(cartData.cart.patronQuestionInput) : ''
    setInitialValues({ isPatron: patronQuestionInitialValue })
  }, [cartData])

  if (!cartData || isCartLoading || !initialValues) {
    return <SkeletonPatronQuestion />
  }

  // Render nothing if there should not be a patron question
  if (cartData.cart.patronQuestionType !== PatronQuestionType.PATRON_QUESTION_TYPE_PAST_ATTENDANCE) {
    return null
  }

  const { venue } = cartData.cart

  const handleChange = (values: PatronQuestionInitialValues) => {
    if (values.isPatron === undefined) return

    const isPatron = values.isPatron === 'true'

    // eslint-disable-next-line  @typescript-eslint/no-floating-promises
    setPatronQuestionOnCart({ variables: { cartId: cartId as string, isPatron } })
  }

  return <PatronQuestionComponent initialValues={initialValues} venueName={venue.name} handleChange={handleChange} />
}

export default PatronQuestion
